<div class="row my-2">
  <div class="col-12">
    <it-breadcrumb separator="/">
      <it-breadcrumb-item *ngFor="let item of items" class="me-1" [href]="item.link">
        {{ item.label }}
      </it-breadcrumb-item>
    </it-breadcrumb>
  </div>
  <div class="col-6 mt-2">
    <h3>Anagrafica Ente</h3>
  </div>
  <div class="col-6 d-flex justify-content-end">
    <it-back-button></it-back-button>
  </div>
</div>
@if (formEnte) {
<form [formGroup]="formEnte">
  <div class="row g-3 mt-4">
    <div class="col-12 col-lg-12">
      <it-input type="text" id="ragioneSociale" label="Ragione sociale" formControlName="ragioneSociale"
        [readonly]="true"></it-input>
    </div>
    <div class="col-12 col-lg-6">
      <it-input type="text" id="codiceFiscale" label="Codice fiscale" formControlName="codiceFiscale"
        [readonly]="true"></it-input>
    </div>
    <div class="col-12 col-lg-6">
      <it-input type="text" id="codiceAusa" label="Codice Ausa" formControlName="codiceAusa"
        [readonly]="true"></it-input>
    </div>
    <div class="col-12 col-lg-6">
      <it-input type="date" id="dataInizioConvenzione" label="Data inizio convenzione"
        formControlName="dataInizioConvenzione" [readonly]="true"></it-input>
    </div>
    <div class="col-12 col-lg-6">
      <it-input type="date" id="dataFineConvenzione" label="Data fine convenzione" formControlName="dataFineConvenzione"
        [readonly]="true"></it-input>
    </div>
  </div>
</form>
}

<div class="pt-2 mt-2 pb-2 mb-2">
  <h3 class="fw-bold">Unità organizzative</h3>
  <div class="row g-4">
    <div class="col-12">

      @if (!ente.isSolaLettura) {
      <div class="d-flex justify-content-end">
        <button type="button" itButton="primary" (click)="add()">
          Aggiungi
        </button>
      </div>
      }
      <it-modal #unitaOrganizzativaModal="itModal" size="lg">
        <ng-container modalTitle>Unità organizzativa</ng-container>
        <ng-container description>
          <form class="mt-2" [formGroup]="form">
            <div class="row">
              <div class="col-6">
                <it-input label="Descrizione" type="text" formControlName="descrizione" #descrizione>
                  <ng-container error>
                    @if (descrizione.hasError('required')) {
                    <div>Il campo è obbligatorio</div>
                    }
                    @if (!descrizione.hasError('required') && descrizione.hasError('whitespace')) {
                    <div>Il campo non è valido</div>
                    }
                    @if (descrizione.hasError('maxlength')) {
                    <div>Limite caratteri superato</div>
                    }
                  </ng-container>
                </it-input>
              </div>
              <div class="col-6">
                <it-input label="Centro di costo" type="text" formControlName="centroDiCosto" #centroDiCosto>
                  <ng-container error>
                    @if (centroDiCosto.hasError('required')) {
                    <div>Il campo è obbligatorio</div>
                    }
                    @if (!centroDiCosto.hasError('required') && centroDiCosto.hasError('whitespace')) {
                    <div>Il campo non è valido</div>
                    }
                    @if (centroDiCosto.hasError('maxlength')) {
                    <div>Limite caratteri superato</div>
                    }
                  </ng-container>
                </it-input>
              </div>
            </div>
          </form>
        </ng-container>
        <ng-container footer>
          <button itButton="primary" size="sm" type="button" [disabled]="form.invalid || ente.isSolaLettura"
            (click)="submit()">Salva</button>
        </ng-container>
      </it-modal>

    </div>
    @if (listUnitaOrganizzativa.length > 0) {
    <it-table itSort (sortChange)="sortData($event)">
      <ng-container thead>
        <tr>
          <th it-sort-header="descrizione" scope="col">Descrizione</th>
          <th it-sort-header="centroDiCosto" scope="col">Centro di costo</th>
          <th scope="col"></th>
        </tr>
      </ng-container>

      <ng-container tbody>
        @for (element of listUnitaOrganizzativa; track $index) {
        <tr>
          <td [title]="element.descrizione">{{element.descrizione}}</td>
          <td [title]="element.centroDiCosto">{{element.centroDiCosto}}</td>
          <td class="col-width-100">
            @if (element.isAttivo) {

            <a onclick="return false" href="/" (click)="edit(element)" title="Modifica" class="me-2">
              <it-icon name="pencil" color="primary" size="sm"></it-icon>
            </a>
            }
            @if (element.isCancellazioneConsentita && !ente.isSolaLettura) {
            <a onclick="return false" href="/" (click)="confirmModal.toggle()" title="Elimina">
              <it-icon name="delete" color="danger" size="sm"></it-icon>
            </a>
            <it-modal #confirmModal="itModal" closeButton="false">
              <ng-container modalTitle>Conferma eliminazione</ng-container>
              <ng-container description>
                <p>Sei sicuro di voler eliminare l'unità organizzativa <strong>{{element.descrizione}}</strong>?</p>
              </ng-container>
              <ng-container footer>
                <button itButton="outline-primary" size="sm" type="button" data-bs-dismiss="modal">Annulla</button>
                <button itButton="primary" size="sm" type="button" (click)="delete(element)"
                  data-bs-dismiss="modal">Conferma</button>
              </ng-container>
            </it-modal>
            }
          </td>
        </tr>
        }
      </ng-container>
    </it-table>

    } @else {
    <h5 class="text-center">Nessuna unità organizzativa presente</h5>
    }
    <it-pagination *ngIf="totalPages > 0" alignment="center" [currentPage]="currentPage" [pageNumbers]="totalPages"
      [currentChanger]="pageOffset" (changerEvent)="changerEvent($event)" (pageEvent)="getPage($event)">
    </it-pagination>
  </div>
</div>
<it-notifications></it-notifications>
